import React, { useContext, useState } from 'react'
import { TbMapPin, TbWorld } from 'react-icons/tb'
import SHSpeakerCard from '../../../components/SHSpeakerCard/SHSpeakerCard'
import './SHEventSpeakers.css'
import { useLanguage } from '../../../../../LanguageProvider';
import AddSpeakerModal from '../../../components/AddSpeakerModal/AddSpeakerModal';
import Services from '../../../../../services/Services';
import { useToaster } from '../../../../../ToasterProvider';
import { GeneralContext } from '../../../../../GeneralProvider';

export default function SHEventSpeakers({ event, isAdmin, getEventDetails }) {
    const { setCreateProjectLoading } = useContext(GeneralContext);
    const { toastError, toastSuccess } = useToaster();
    const token = localStorage.getItem("token")
    const { getTranslation } = useLanguage();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleCloseModal = () => {
        setIsModalOpen(false)
    }

    const handleAddSpeaker = (name, lastname, about, image, speakingAboutTitle, speakingAbout, linkedin) => {
        setCreateProjectLoading(true)
        Services.SocialHiveAddSpeaker(token, event?.channelID, event?.eventID, name, lastname, speakingAboutTitle, speakingAbout, about, image, linkedin)
            .then((res) => {
                if (res.data.status) {
                    toastSuccess(getTranslation("successMessage"))
                    getEventDetails()
                    handleCloseModal()
                } else {
                    toastError(getTranslation("somethingWentWrong"));
                }
                setCreateProjectLoading(false)
            })
            .catch((err) => {
                console.error(err);
                toastError(getTranslation("somethingWentWrong"));
            });
    }

    const monthKeys = [
        'january', 'february', 'march', 'april',
        'may', 'june', 'july', 'august',
        'september', 'october', 'november', 'december'
    ];

    function formatToMonthDashDay(timestamp) {
        const date = new Date(timestamp * 1000);
        const monthKey = monthKeys[date.getMonth()];
        const monthName = getTranslation(monthKey);           // örn. "October" veya "Ekim"
        const shortMonth = monthName.slice(0, 3);            // "Oct" veya "Eki"
        const day = String(date.getDate()).padStart(2, '0'); // "03"
        return `${shortMonth} - ${day}`;
    }

    return (
        <div className="sh-info-main" style={{ height: 'fit-content' }}>
            <div className="sh-image-wrapper" style={{ padding: 0 }}>
                <img src={event?.cover} height={250} alt={event?.title} className="sh-card-image" />
                <span className="sh-event-card-date-badge">{formatToMonthDashDay(event?.eventStartDateTime)}</span>
            </div>
            <h1 className="sh-event-title">{event?.title}</h1>
            {event?.isOnline === "1" ?
                <div className="sh-location">
                    <TbWorld className="sh-icon" />
                    <span>{event?.website}</span>
                </div>
                :
                <div className="sh-location">
                    <TbMapPin className="sh-icon" />
                    <span>{event?.locationAddress}</span>
                </div>
            }

            <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '15px' }}>
                <span className='sh-speakers-title'>{getTranslation('speakers')}</span>
                {isAdmin === "1" &&
                    <span className="sh-details-title" onClick={() => setIsModalOpen(true)} >
                        <span>{getTranslation('addNewSpeaker')}</span>
                    </span>}
            </div>

            {event?.speakers ? (
                <div className="social-hive-speakers-grid">
                    {event?.speakers.map((speaker, index) => (
                        <SHSpeakerCard
                            isAdmin={isAdmin}
                            key={index}
                            name={`${speaker.name} ${speaker.lastname}`}
                            image={speaker.image}
                            title={speaker.speakingAboutTitle === "-" ? speaker.about : (speaker.speakingAboutTitle || speaker.about)}
                            linkedin={speaker?.socialMediaLinks?.linkedin || speaker?.linkedin}
                            eventID={event?.eventID}
                            speakerID={speaker.speakerID}
                            getEventDetails={getEventDetails}
                        />
                    ))}
                </div>
            ) : (
                <div className="sh-location">
                    <span>{getTranslation('noSpeakersYet')}</span>
                </div>
            )}


            <AddSpeakerModal
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                onCreate={handleAddSpeaker}
                isWorkspace={true}
            />
        </div>
    )
}
